module.exports = __webpack_public_path__ + "static/img/img_awards_4en.bdf4ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/img_awards_4en.png
// module id = ixNt
// module chunks = 15